import { z } from "zod";

import { constantsData } from "@/data";

export const forgetPasswordFormSchema = z.object({
    email: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ).email(constantsData.msgs.notValidEmail),
});
